import { memo, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex, Skeleton, Collapse, useDisclosure, AbsoluteCenter, Divider } from "@chakra-ui/react";
import { getDsrAnalyticsCategoryDetails } from '../../analytics/actions/dsr-analytics-actions'
import { getUserDetailsUsingDsrMembersArray } from '../../profile/helpers/user-helper';

import { formatSecondsValueDisplay } from '../../global/helpers/time-format-helpers';
import LaunchdeckTag from '../../global/components/helper-components/components/LaunchdeckTag';
import { displayReactIcon, getDisplayIdentifier } from '../helpers/dsr-display-helpers';
import LaunchdeckShortLogo from '../../global/components/helper-components/components/LaunchdeckShortLogo';
import StripeCheckoutButton from '../../payments/components/StripeCheckoutButton';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import ProAccountNeededIcon from '../../global/components/product-marketing/ProAccountNeededIcon';
import { pageActivityLog } from '../../global/styles/tour-datasets/analytics-tour-data';


function DsrPageStats({
  dsrId,
  useTourData,
  pageStatsAvailable,
  displaySubscriptionNudge,
  dsrPageAnalytics,
  handleLoadPageData,
  getDsrAnalyticsCategoryDetails,
  dsrTeamMembersRedux,
  isMobileView
}) {

  const { isOpen, onToggle } = useDisclosure()
  const history = useHistory()
  const targetRef = useRef(null); // Create a ref for the target component
  const [displayPageStats,setDisplayPageStats] = useState(null)

  const handleScrollToComponent = () => {
    // Scroll to the specific component
    targetRef.current.scrollIntoView({
      behavior: "smooth", // Smooth scrolling effect
      block: "start", // Scroll to the top of the component
    });
  };

    useEffect(()=> {
      if (useTourData) {
        setDisplayPageStats(pageActivityLog)
      } else {
        if (Array.isArray(dsrPageAnalytics))
          setDisplayPageStats(dsrPageAnalytics)
      }
    },[useTourData])

  useEffect(() => {
    if (!pageStatsAvailable && getDsrAnalyticsCategoryDetails) {
      getDsrAnalyticsCategoryDetails({ dsrId, requestType: 'retrieve-dsr-page-analytics' })

      handleLoadPageData()
    }
  }, [getDsrAnalyticsCategoryDetails, handleLoadPageData, dsrId]);


  const handleDisplayBreakdown = () => {
    onToggle()
  }

  const renderStatRows = () => {
    if (Array.isArray(displayPageStats)) {
      const displayRows = displayPageStats?.map((pageStats, index) => {
        const { pageIdentifier, pageTitle, pageTotalEngagementTime, pageUniqueViews, pageUniqueVisitors, pageUniqueViewsBreakdown } = pageStats || {};

        const renderNudgeBanner = () => {
          if (index === 0) {
            return (
              <Box
                border='1px solid' borderColor='gray.300' rounded='0.25em' p='0.5em' m='1em'
                bgGradient="linear(to-r, #FF2847, #29ABE2)"
              >

                <Flex
                  w='100%'
                  rounded='0.25em'
                  color='brandDark.500'
                  justify='space-between'
                  align='flex-start'
                  p='0.5em'
                  border='1px solid'
                  borderColor='brand.300'
                  bg='white'
                >
                  <Flex justify='flex-start' gap={4}>

                    <Box px='0.5em'>
                      <Flex pt='0.5em' align='flex-start' justify='space-between' w='100%'>
                        <LaunchdeckShortLogo boxSize='1.5em' />
                      </Flex>
                      <Box fontSize='0.875em' fontWeight='600' mt='0.5em' textAlign={['center', 'left']}>Know where your decision-makers true interests lie</Box>
                      <Box fontSize='0.8em' color='gray.500' mt='0.5em' textAlign={['center', 'left']}>See which pages are they spending the most time on, at just $1 a day</Box>

                      <Box mt='2em'>
                        <Flex justify={['center', 'flex-start']} w='100%' mt='1em'>
                          <StripeCheckoutButton sourceRoute={`${history.location.pathname}`} fontSize='0.8em' buttonText="Upgrade" closeModalWhenClicked={true} />
                        </Flex>

                        {!isMobileView &&
                          <Box fontSize='0.7em' color='gray.500' fontStyle='italic' mt='0.5em' textAlign='left'>

                            We greatly value your support. Unlike many investors-first tech companies, we use the funds to provide a user-first service & keep the lights on.
                            {/* // TODO: Find out more blog*/}
                            {/* // Check out our Bluesky socials for more information */}
                          </Box>
                        }
                      </Box>
                    </Box>
                  </Flex>

                </Flex>
              </Box>
            )

          } else {

            return (
              <Box border='1px solid' borderColor='gray.300' rounded='0.25em' m='1em'>
                <Flex gap={4} justify={'center'} align='center' direction={isMobileView && 'column-reverse'} p='0.5em' bg='white' rounded='0.25em' cursor='pointer' onClick={() => handleScrollToComponent()} >
                  <Box fontSize='0.7em'>Get to know all your guests' interests a lot better. Upgrade today </Box>
                  <ProAccountNeededIcon />
                </Flex>
              </Box>
            )
          }

        }

        const renderBreakdownStats = () => {
          if (Array.isArray(pageUniqueViewsBreakdown)) {

            if (pageUniqueViewsBreakdown.length < 1) {
              return <Box fontSize='0.875em' my='1em'>No breakdown available</Box>
            }
            const displayBreakdownRows = pageUniqueViewsBreakdown?.map(((userPageStat, rowIndex) => {
              let displayIdentifier = ""
              const { visitorUserId, visitorEngagementTimeSeconds, visitorSessonCount } = userPageStat || {};
             
              if (useTourData) {
                displayIdentifier = userPageStat?.tourMemberName
              } else {
                const userProfile = getUserDetailsUsingDsrMembersArray(dsrTeamMembersRedux, visitorUserId);
                displayIdentifier = getDisplayIdentifier(userProfile, true);
              }
              

              return (
                <Flex key={`detailed-breakdown-${visitorUserId}-${rowIndex}`} w='100%' align='center' direction={["column", "column", "row", "row"]}
                  py='0.5em' mb={['0.5em', '0.5em', '0', '0']}>

                  <Flex flex='5' justify='flex-start' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400' lineHeight='1.5em' color='brandDark.500' textAlign={["center", "center", "", ""]} pl={['0', '0', '1em', '1em']}>
                    <Flex justify='flex-start' flexWrap='wrap' w='100%' textAlign='left' maxW='20em' px='2em'>{displayIdentifier}</Flex>
                  </Flex>
                  <Flex flex='5' w='100%' my={["0.5em", "0.5em", "", ""]} >
                    <Box flex='2' justify='flex-start' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400' lineHeight='1.5em' color='brandDark.500'>
                      <Box color='gray.500' textAlign={['center', 'center', 'center', 'center']} display={['', '', 'none', 'none']}>Sessions</Box>
                      <Box textAlign={["center", "center", "center", "center"]} fontSize={["0.8em", "0.8em", "0.875em", "0.875em"]}> {visitorSessonCount}</Box>
                    </Box>
                    <Box flex='2' justify='flex-start' fontSize={['0.75em', '0.75em', '0.875em', '0.875em']} fontWeight='400' lineHeight='1.5em' color='brandDark.500'>
                      <Box color='gray.500' textAlign={['center', 'center', 'center', 'center']} display={['', '', 'none', 'none']}>Time Spent</Box>
                      <Box textAlign={["center", "center", "center", "center"]} fontSize={["0.8em", "0.8em", "0.875em", "0.875em"]}>  {formatSecondsValueDisplay(visitorEngagementTimeSeconds)}</Box>
                    </Box>

                    <Box flex='1' display={['none', 'none', 'block', 'block']} color='brandDark.500' justify='flex-end' align='center'>
                      {/* <AccordionIcon /> */}
                    </Box>
                  </Flex>


                </Flex>
              )
            }))
            return <Box w='100%'
              bg='gray.50'
              rounded='0.25em' py='0.25em'
            >
              {displayBreakdownRows}
              {displaySubscriptionNudge && renderNudgeBanner()}
            </Box>
          } else {
            return null;
          }
        }



        return (
          <Box key={`dsr-analytics-stats-${pageIdentifier}`} w='100%' py='0.5em' align='center' px={['0', '0', '1.5em', '1.5em']}>
            <Flex w='100%' align='center' direction={["column", "column", "row", "row"]} >
              <Flex flex='3' justify={isMobileView ? 'center' : "flex-start"} align='center' fontSize='0.75em' fontWeight='400' lineHeight='1.5em' color='brandDark.500'
                bg={isMobileView && 'gray.100'} rounded='0.5em' w={isMobileView && '100%'} p={isMobileView && '0.2em'} textAlign='left'>
                <span style={{ marginRight: '0.5em' }}> {displayReactIcon('customised-page', '1.5em')}</span>{pageTitle}
              </Flex>

              <Flex flex='7' w='100%' my={["0.5em", "0.5em", "", ""]} >
                <Box flex='2' justify='flex-start' fontSize='0.875em' fontWeight='400' lineHeight='1.5em' color='brandDark.500'>
                  <Box fontSize='0.75em' color='gray.500' textAlign={['center', 'center', 'center', 'center']} display={['', '', 'none', 'none']}>Visitors</Box>
                  <Box textAlign={["center", "center", "", ""]} fontSize={["0.8em", "0.8em", "0.875em", "0.875em"]}> {pageUniqueVisitors}</Box>
                </Box>

                <Box flex='2' justify='flex-start' fontSize='0.875em' fontWeight='400' lineHeight='1.5em' color='brandDark.500'>
                  <Box fontSize='0.75em' color='gray.500' textAlign={['center', 'center', 'center', 'center']} display={['', '', 'none', 'none']}>Views</Box>
                  <Box textAlign={["center", "center", "", ""]} fontSize={["0.8em", "0.8em", "0.875em", "0.875em"]}> {pageUniqueViews}</Box>
                </Box>
                <Box flex='2' justify='flex-start' fontSize='0.875em' fontWeight='400' lineHeight='1.5em' color='brandDark.500'>
                  <Box fontSize='0.75em' color='gray.500' textAlign={['center', 'center', 'center', 'center']} display={['', '', 'none', 'none']}>Time spent</Box>
                  <Box textAlign={["center", "center", "", ""]} fontSize={["0.8em", "0.8em", "0.875em", "0.875em"]}> {formatSecondsValueDisplay(pageTotalEngagementTime)}</Box>
                </Box>

                <Box flex='1' display={['none', 'none', 'block', 'block']} fontSize='0.875em' color='brandDark.500' justify='flex-end' align='center'>

                </Box>
              </Flex>

            </Flex>

            <Collapse in={(isMobileView || useTourData) ? true : isOpen} animateOpacity>
              <Box mt='1.5em' position='relative' mb={['1.5em', '1.5em', '0.5em', '0.5em']} px={['25%', '25%', '15em', '15em']}>
                <Divider borderColor='brand.300' />
                <AbsoluteCenter bg='white' px='1em' fontSize='0.7em' fontWeight='600' color='gray.700'>
                  Breakdown
                </AbsoluteCenter>
              </Box>
              <Box my='1em'>
                {renderBreakdownStats()}
              </Box>
              <Divider />
            </Collapse>


          </Box>
        )
      })

      return <Box minH='50vh'>{displayRows}</Box>;
    } else {
      const skeleton = Array.from({ length: 8 }, (_, index) => (
        <Flex w='100%' px='1.5em' py='0.5em' borderBottom='1px solid' borderColor='gray.200'>
          <Box flex='1' py='0.5em'>
            <Skeleton w='4em' h='1.25em' py='0.5em' />
          </Box>
          <Box flex='1' py='0.5em'>
            <Skeleton w='2em' h='1.25em' py='0.5em' />
          </Box>
          <Box flex='1' py='0.5em'>
            <Skeleton w='5em' h='1.25em' py='0.5em' />
          </Box>
        </Flex>
      ));

      return (
        <Box>
          {skeleton}
        </Box>
      )
    }
  }

  return (
    <Box data-driver="insights-tour-step-7" w='100%' bg='white' rounded='0.5em' h='auto' px='1.5em' ref={targetRef}>

      <Flex w='100%' py='1em' borderBottom='1px solid' borderColor='gray.200' px={['0', '0', '1.5em', '1.5em']}>
        <Flex display={["none", "none", "flex", "flex"]} w='100%' align='center' direction={["column", "column", "row", "row"]}>
          <Box flex='3' justify='flex-start' fontSize='0.75em' fontWeight='400' lineHeight='1.5em' color='gray.500'>
            Page
          </Box>

          <Flex flex='7' w='100%' my={["0.5em", "0.5em", "", ""]} align='center'>

            <Box flex='2' fontSize='0.75em' fontWeight='400' lineHeight='1.5em' color='gray.500' textAlign='center'>
              Unique visitors
            </Box>

            <Box flex='2' fontSize='0.75em' fontWeight='400' lineHeight='1.5em' color='gray.500' textAlign='center'>
              Views
            </Box>

            <Box flex='2' fontSize='0.75em' fontWeight='400' lineHeight='1.5em' color='gray.500' textAlign='center'>
              Time spent
            </Box>

            <Flex flex='1' justify='flex-end' color='brand.500' fontWeight='500' visibility={useTourData && "hidden"} >
              <LaunchdeckTag fontSize='0.75em' bg='brand.500' color='white' onClick={() => handleDisplayBreakdown()}>
                <Box>Details</Box>
              </LaunchdeckTag>
            </Flex>

          </Flex>
        </Flex>

        <Flex display={["flex", "none"]} w='100%' align='center' justify='space-between' pl={['0', '1em']}>
          <Box fontSize='1.25em' fontWeight='500' lineHeight='1.3em' color='brandDark.500' >Page Stats</Box>
        </Flex>

      </Flex>
      {renderStatRows()}
    </Box>

  )
}


const mapStateToProps = (state) => {
  return {
    dsrTeamMembersRedux: state.dsrTeamMembers.members,
    isMobileView: state.mobileViewMode.isMobileView
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDsrAnalyticsCategoryDetails
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrPageStats)))